export default "__VITE_ASSET__BHVkGz9s__"